import { render } from "./LIstShareHolder.vue?vue&type=template&id=8ef69736&scoped=true"
import script from "./LIstShareHolder.vue?vue&type=script&lang=js"
export * from "./LIstShareHolder.vue?vue&type=script&lang=js"

import "./LIstShareHolder.vue?vue&type=style&index=0&id=8ef69736&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ef69736"]])

export default __exports__